/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import React, { useState } from 'react';
import { Form, InputGroup } from 'react-bootstrap';
import * as S from '../../styles';

export interface IEmailInputProps {
  id: string;
  label?: string;
  labelColor?: string;
  errorText?: string;
  value?: string;
  required?: boolean;
  placeholder?: string;
  hasError?: boolean;
  readOnly?: boolean;
  onCompChange?(id: string, payload: any): void;
}

export const EmailInput = ({
  id,
  label,
  labelColor,
  errorText,
  value,
  required,
  placeholder,
  hasError,
  readOnly,
  onCompChange,
}: IEmailInputProps) => {
  const [textValue, setTextValue] = useState(value ?? '');
  const onChange = (id: string, e: any) => {
    setTextValue(e?.target?.value);
    onCompChange && onCompChange(id, e?.target?.value);
  };

  const _renderLabelIf = () => {
    if (label) {
      return (
        <S.FormLabel color={labelColor}>
          {label}
          {required && <sup style={{ color: 'red' }}>*</sup>}
        </S.FormLabel>
      );
    }
    return null;
  };

  const _renderErrorTextIf = () => {
    if (hasError && errorText) {
      return (
        <S.FeedbackOtherLabel type="tooltip">{errorText}</S.FeedbackOtherLabel>
      );
    }
    if (hasError && errorText) {
      return <S.FeedbackLabel type="invalid">{errorText}</S.FeedbackLabel>;
    }
    return null;
  };

  return (
    <>
      <Form.Group id={id} className="formgroup">
        {_renderLabelIf()}
        <InputGroup>
          <Form.Control
            // className="formcontrol shadow-none"
            style={{ border: 'none' }}
            value={textValue}
            onChange={onChange.bind(null, id)}
            required={required}
            type="email"
            placeholder={placeholder}
            readOnly={readOnly}
          />
          {_renderErrorTextIf()}
        </InputGroup>
      </Form.Group>
    </>
  );
};

EmailInput.defaultProps = {
  required: false,
  hasError: false,
};
